export * from './app';
export * from './common';
export * from './custom';
export * from './toast';
// 结算保留
export * from './placeOrder';
export * from './user';
export * from './membershipLevel';

import { createPinia } from 'pinia';

const pinia = createPinia();

export default pinia;
